export default __webpack_public_path__ + "static/char-s-50-ja-a0e00c5753ec4f0b502998697d751b03.png";